<template>
  <div class="subscription">
    <div class="subscription__card">
      <div class="subscription__card__border mb-8 lg:mb-0">
        <img class="mr-24" width="80" height="80" src="./subscription/subscription.svg" alt="" loading="lazy">
        <div>
          <h4 class="font-bold mb-4">{{ $t('subscription.title') }}</h4>
          <p class="text-sm text-grey-darker mb-24">{{ $t('subscription.msg') }}
            <router-link :to="{name: 'UserTerm'}" class="text-blue no-underline" target="_blank">{{ $t('policyAgreement.term') }}</router-link>
            <span> {{ $t('policyAgreement.and') }} </span>
            <a :href="`https://www.owlting.com/portal/about/privacy?lang=${externalLinkLang}`" class="text-blue no-underline" target="_blank">{{ $t('privacyPolicy') }}</a>
          </p>
          <label class="input-buttons flex w-full justify-between"
            :class="{ 'input-error': !_isEmailFormatValid(subscribeEmail) && startEmailValid }">
            <input class="input w-full flex-1" type="text" :placeholder="$t('subscription.emailMsg')" style="border-top-left-radius: 9999px; border-bottom-left-radius: 9999px;"
              v-model.trim="subscribeEmail" @keydown.enter="onSubscribeClick">
            <button class="subscription__button btn btn-solid btn-blue-light rounded-full" @click="onSubscribeClick"
              :disabled="isSendingEmail">{{ $t('subscription.text') }}</button>
          </label>
        </div>
      </div>
    </div>
    <div class="subscription__card">
      <div class="subscription__card__border mt-8 lg:mt-0">
        <img class="mr-24" width="80" height="80" src="./subscription/invitation.svg" alt="" loading="lazy">
        <div>
          <h4 class="font-bold mb-4">{{ $t('subscription.inviteMsg') }}</h4>
          <p class="text-sm text-grey-darker mb-24">{{ $t('subscription.bannerText') }}</p>
          <button class="btn btn-ghost btn-blue no-underline rounded-full"
            @click="checkDiscountHandler">{{ $t('subscription.lookForDiscount') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import localeMixin from '@/mixins/locale'
import regexRules from '@/mixins/regexRules'

export default {
  name: 'module_Special',
  props: ['meta', 'data'],
  mixins: [localeMixin, regexRules],
  data () {
    return {
      subscribeEmail: '',
      startEmailValid: false,
      isSendingEmail: false
    }
  },
  computed: {
    ...mapGetters('user', [
      'isLogin'
    ])
  },
  methods: {
    ...mapActions([
      'user/subscribeEmail'
    ]),
    onSubscribeClick: function () {
      this.startEmailValid = true
      this.isSendingEmail = true
      if (!this._isEmailFormatValid(this.subscribeEmail)) {
        //! input keydown enter will also close dialog
        setTimeout(() => {
          this.isSendingEmail = false
          this.$modal.show('dialog', {
            text: `<p class="text-center text-lg text-green-dark">${this.$t('validatorErrors.email')}</p>`,
            buttons: [
              {
                title: this.$t('close')
              }
            ]
          })
        }, 100)
        return false
      }

      this['user/subscribeEmail'](this.subscribeEmail)
        .then(res => {
          this.startEmailValid = false
          this.$modal.show('dialog', {
            title: `<p class="text-center text-lg text-green-dark">${this.$t('subscription.subscriptionSuccess')}</p>`,
            text: this.$t('subscription.subscriptionEmail') + this.subscribeEmail,
            buttons: [
              {
                title: this.$t('close')
              }
            ]
          })

          this.subscribeEmail = ''
        })
    },
    checkDiscountHandler () {
      if (this.isLogin) {
        this.$router.push({ name: 'UserPointsInvitation' })
      } else {
        this.$router.push({ name: 'Invitation' })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.subscription
  @apply flex flex-wrap mb-0 bg-grey-lighter
  @screen sm
    @apply bg-transparent
  @screen md
    @apply -mx-8 mb-48
  &__card
    @apply w-full
    @screen lg
      @apply w-1/2
    &__border
      @apply flex flex-col items-start border border-grey-lightest p-24 mx-16 bg-white
      border-radius: 1.25rem
      @screen sm
        @apply flex flex-row
      @screen lg
        @apply justify-start h-full mx-8
  &__button
    padding: .5rem 1rem
    border-top-left-radius: 0
    border-bottom-left-radius: 0
  .inline-link
    @apply text-blue no-underline
    &:hover
      @apply underline
</style>
